import { Column, Entity, ManyToOne, OneToMany, PrimaryColumn } from 'typeorm';

import { SubjectDetail } from '../../_objects/subject';
import { BaseSchema } from '../abstracts/base.schema';
import { TenantIdSchemaBase } from '../interfaces/tenantId.base';
import { InspectionSchema } from './inspection.schema';
import { SubjectModelSchema } from './subjectModel.schema';
import { SubjectAttributesSchema } from './subject-attributes.schema';

/**
 * SubjectSchema インターフェイス。
 */
export interface ISubjectSchema {
  schemaVersion: string;
  tenantId: string;
  createdBy: string;
  lastUpdatedBy: string;
  id: string;
  serialNo: string;
  subjectModelId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  isValid: boolean;
  createDate: string;
  lastUpdateDate: string;
  isDeleted: boolean;
  isOfflineData: boolean;
  inspections: InspectionSchema[];
  subjectModel: SubjectModelSchema;
}

@Entity()
export class SubjectSchema extends BaseSchema implements TenantIdSchemaBase {
  @PrimaryColumn()
    id: string;

  @Column({ nullable: true, length: 100 })
    serialNo: string | null;

  @Column({ nullable: true })
    subjectModelId: string | null;

  // 属性はSubjectAttributesスキーマに切り出したが、初期マイグレーションのために定義を残す
  // マイグレーション以外では未使用のため、念のためupdate=falseを設定
  @Column({ nullable: true, update: false })
    owner: string | null;

  @Column({ nullable: true, update: false })
    country: string | null;

  @Column({ nullable: true, update: false })
    state: string | null;

  @Column({ nullable: true, update: false })
    district: string | null;

  @Column({ nullable: true, update: false })
    site: string | null;

  @Column({ nullable: true, update: false })
    project: string | null;

  @Column()
    isValid: boolean;

  @Column({ nullable: true })
    createDate: string | null;

  @Column({ nullable: true })
    lastUpdatedBy: string | null;

  @Column({ nullable: true })
    lastUpdateDate: string;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    isOfflineData: boolean | null;

  // relations

  @OneToMany('InspectionSchema', 'subject')
    inspections: InspectionSchema[];

  @OneToMany('SubjectAttributesSchema', 'subject')
    subjectAttributes: SubjectAttributesSchema[];

  @ManyToOne('SubjectModelSchema', 'subjects')
    subjectModel: SubjectModelSchema;

  constructor(tenantId: string, subject?: SubjectDetail) {
    super(subject?.schemaVersion, tenantId, subject?.createdBy, subject?.lastUpdatedBy);

    if (subject) {
      this.id = subject.id;
      this.serialNo = subject.serialNo;
      this.subjectModelId = subject.subjectModelId;
      this.owner = subject.owner;
      this.country = subject.country;
      this.state = subject.state;
      this.district = subject.district;
      this.site = subject.site;
      this.project = subject.project;
      this.isValid = subject.isValid;
      this.createDate = subject.createDate;
      this.lastUpdatedBy = subject.lastUpdatedBy;
      this.lastUpdateDate = subject.lastUpdateDate;
      this.isDeleted = subject.isDeleted;
      this.isOfflineData = subject.isOfflineData;
    }
  }
}

export class SubjectSchemaQueryOpt {
  tenantId: string;
  subjectModelId: string;
  enabledOnly: boolean;
  isAliveOnly: boolean;

  constructor(tenantId: string, subjectModelId: string, enabledOnly: boolean, isAliveOnly: boolean) {
    this.tenantId = tenantId;
    this.subjectModelId = subjectModelId;
    this.enabledOnly = enabledOnly;
    this.isAliveOnly = isAliveOnly;
  }
}
